<template>
  <v-row>
    <v-col cols="12" sm="12" offset-sm="0">
      <v-card>
        <v-card-title>
          EUREC<sup>4</sup>A forecast at IAC ETH Zurich
        </v-card-title>
        <v-card-text>
          Forecast based on ECMWF
        </v-card-text>
        <v-container fluid>
          Website URL:
          <a href="https://data.iac.ethz.ch/eurec4a/" target="blank"
            >https://data.iac.ethz.ch/eurec4a/</a
          ><br />
          <strong
            >To get access information to connect to the website send an email
            to: leonie.villiger (at) env.ethz.ch</strong
          ><br /><br />

          <a href="https://data.iac.ethz.ch/eurec4a/" target="blank"
            ><img src="photos/eth-website.png" style="width:800px;"
          /></a>
        </v-container>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data: () => ({})
};
</script>
